import config from '@conf'
import { DetailsRequestBuilder } from './modules/details_requests_builder'
import { KDFRequestBuilder } from './modules/kdf_request_builder'
import { WalletRequestBuilder } from './modules/wallet_request_builder'
import { NotificationsRequestBuilder } from './modules/notifications_request_builder'
import { UserIDRequestBuilder } from './modules/user_id_request_builder'
import { UsersRequestBuilder } from './modules/users_request_builder'
import { V2RequestBuilder } from './modules/v2_request_builder'
import { OperationBuilder } from '../operation_builder/operation_builder'
import { ChartsRequestBuilder } from './modules/charts_request_builder'
import { IntegrationsRequestBuilder } from './modules/integrations_request_builder'
import { DataRequestBuider } from './modules/data_request_builder'
import { WithdrawalsRequestBuilder } from './modules/withdrawals_request_builder'
import { RequestBuilder } from './request_builder'
import { WebshopRequestBuilder } from './modules/webshop_request_builder'
import { ExchangeRequestBuilder } from './modules/exchange_request_builder'
import {OwnerRequestBuilder} from './modules/owner_request_builder'
import {SettingsRequestBuilder} from './modules/settings_request_builder'
import {WithdrawalUSDTRequestBuilder} from './modules/witdrawal_usdt_request_builder'

export class Request {
  operation () {
    return new OperationBuilder(config.HORIZON_SERVER)
  }

  details () {
    return new DetailsRequestBuilder(config.HORIZON_SERVER)
  }

  charts () {
    return new ChartsRequestBuilder(config.HORIZON_SERVER)
  }

  commonData () {
    return new DataRequestBuider(config.HORIZON_SERVER)
  }

  integrations () {
    return new IntegrationsRequestBuilder(config.HORIZON_SERVER)
  }

  kdf () {
    return new KDFRequestBuilder(config.HORIZON_SERVER)
  }

  userId () {
    return new UserIDRequestBuilder(config.HORIZON_SERVER)
  }

  users () {
    return new UsersRequestBuilder(config.HORIZON_SERVER)
  }

  wallets () {
    return new WalletRequestBuilder(config.HORIZON_SERVER)
  }

  notifications () {
    return new NotificationsRequestBuilder(config.HORIZON_SERVER)
  }

  webshop () {
    return new WebshopRequestBuilder(config.HORIZON_SERVER)
  }

  owner () {
    return new OwnerRequestBuilder(config.HORIZON_SERVER)
  }

  withdawals () {
    return new WithdrawalsRequestBuilder(config.HORIZON_SERVER)
  }

  withdrawalUsdt () {
    return new WithdrawalUSDTRequestBuilder(config.USDT_LISTENER_SERVER)
  }

  v2 () {
    return new V2RequestBuilder(config.HORIZON_SERVER)
  }

  exchange () {
    return new ExchangeRequestBuilder(config.HORIZON_SERVER)
  }

  settings () {
    return new SettingsRequestBuilder(config.HORIZON_SERVER)
  }

  root () {
    return new RequestBuilder(config.HORIZON_SERVER)
  }
}

export default new Request()



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/index.js